import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Slider,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  AppBar,
  Toolbar,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  FormControlLabel,
  Select,
  Modal,
  Button,
  FormControl,
  InputLabel,
  TablePagination,
} from "@mui/material";
import { CalendarToday, Notifications, Search } from "@mui/icons-material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AdminProductCard, SearchComponent } from "../../components";
import ProductFormAdmin from "./productForm";

import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch, useDelete, useUpdate } from "../../hooks";
import { SnackBarComponent } from "../../components";

export default function AdminProduct() {
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    severity: "success", // Default severity
    message: "",
    position: { vertical: "top", horizontal: "center" },
  });
  const [searchValue, setSearchValue] = useState("");
  const loginToken = useSelector((state) => state.user.logintoken);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [selectedCategory, setSelectedCategory] = React.useState("");
  const [selectedBrand, setSelectedBrand] = React.useState("");
  const [selectedDeal, setSelectedDeal] = React.useState("");

  const [isModalOpen, setModalOpen] = useState(false);
  const [priceRange, setPriceRange] = useState([0, 75000]);
  const [sortOption, setSortOption] = useState("");
  const [categoriesData, setCategoriesData] = useState([]);
  const [brandsData, setBrandsData] = useState([]);
  const [productsAllData, setProductsAllData] = useState([]);
  const [productForm, setProductForm] = useState(false);
  const [menuData, setMenuData] = useState();
  const [isEditing, setIsediting] = useState(false);

  const handleSliderChange = (event, newValue) => {
    // console.log("newValue",event);
    console.log("newValue", newValue);
    if (Array.isArray(newValue)) {
      setPriceRange(newValue); // Update state with new slider values
    }
  };
  useEffect(() => {
    document.title = "Sthanick | Product Management";
  }, []);

  const handleSortChange = (event) => {
    setSortOption(event.target.value);
  };

  const handleModalOpen = () => setModalOpen(true);
  const handleModalClose = () => setModalOpen(false);

  useEffect(() => {
    fetchData();
    fetchBrands();
    fetchProducts();
  }, []);

  useEffect(() => {});

  // Categories
  const {
    data: categoryData,
    isLoading,
    error,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllCategories"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  // Brnads
  const {
    data: BrandsData,

    error: brnadsError,
    fetchData: fetchBrands,
  } = useFetch(BASE_URL_TEST + urls("getAllBrands"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: deletedProductData,
    isLoading: deletedProductLoadinLoading,
    error: deletedProductError,
    deleteData: fetchDeleteData,
  } = useDelete(BASE_URL_TEST, {
    method: "DELETE",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  // Products
  const {
    data: productsData,

    error: productsError,
    fetchData: fetchProducts,
  } = useFetch(BASE_URL_TEST + urls("getAllProducts"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  // Categoreis useEffect
  useEffect(() => {
    if (error) {
    } else if (categoryData && categoryData["status"] === true) {
      console.log("categoryData product", categoryData["data"]);
      setCategoriesData(categoryData["data"]);
    }
  }, [categoryData, error]);

  // brands UseEffect
  useEffect(() => {
    if (error) {
    } else if (BrandsData && BrandsData["status"] === true) {
      console.log("BrandsData product", BrandsData["data"]);
      setBrandsData(BrandsData["data"]);
    }
  }, [BrandsData, brnadsError]);

  // Products UseEffect
  useEffect(() => {
    if (productsError) {
    } else if (productsData && productsData["status"] === true) {
      console.log("productsData product", productsData["data"]);
      setProductsAllData(productsData["data"]);
    }
  }, [productsData, productsError]);

  // Product Deleteion UseEFfrec
  useEffect(() => {
    if (deletedProductError) {
    } else if (deletedProductData && deletedProductData["status"] === true) {
      console.log("deletedProductData", deletedProductData);
      setSnackbarState({
        ...snackbarState,
        open: true,
        message: deletedProductData["message"],
        position: { vertical: "top", horizontal: "center" },
        severity: "success",
      });
      // setModalOpen(false);
      // handleMenuClose();
      fetchProducts();
    }
  }, [deletedProductData, deletedProductError]);

  const handleOnBack = (value) => {
    console.log("valuemodal", value);
    setModalOpen(value);
    fetchProducts();
  };

  const handleSnackBar = (snackBarValue) => {
    setSnackbarState({
      ...snackbarState,
      open: snackBarValue,
      message: "Product Added Successfully",
    });
  };

  const handleSnackbarClose = () => {
    setSnackbarState((prev) => ({ ...prev, open: false }));
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = (value) => {
    setSearchValue(value);
  };

  const parsePrice = (priceString) => {
    return parseFloat(priceString.replace(/[^0-9.]/g, ""));
  };

  // const filteredData = searchValue
  // ? productsAllData.filter(item =>
  //     item.name.toLowerCase().includes(searchValue.toLowerCase()) ||
  //     item.description.toLowerCase().includes(searchValue.toLowerCase())
  //   )
  // : productsAllData;

  const filteredData = productsAllData.filter((item) => {
    const itemPrice = Number(item.regularPrice);

    const nameMatch = item.name
      .toLowerCase()
      .includes(searchValue.toLowerCase());
    const descriptionMatch = item.description
      .toLowerCase()
      .includes(searchValue.toLowerCase());

    const priceMatch = itemPrice >= priceRange[0] && itemPrice <= priceRange[1];
    console.log("pricematch", itemPrice, priceRange[0], priceRange[1]);

    const categoryMatch = selectedCategory
      ? item.category_id === selectedCategory
      : true;
    const brandMatch = selectedBrand ? item.brand_id === selectedBrand : true;

    const searchMatch = searchValue ? nameMatch || descriptionMatch : true;

    return searchMatch && categoryMatch && brandMatch && priceMatch;
  });

  console.log("filtered", filteredData);

  const handleMenuClick = (data) => {
    console.log("menudata", data);
    setMenuData(data);
    setModalOpen(true);
  };
  const handleDeleteClick = (id) => {
    console.log("menudatadelete", id);
    const deleteUrl = urls("deleteProduct", id);
    fetchDeleteData(deleteUrl);
  };
  const handleEditing = (value) => {
    setIsediting(value);
  };

  return (
    <Box sx={{ display: "flex" }}>
      {/* Sidebar */}
      {/* <Box
  sx={{
    width: "20%",
    backgroundColor: "#f9f9f9",
    p: 2,
    borderRadius: 2,
  }}
>
 
</Box> */}
      <SnackBarComponent
        open={snackbarState.open}
        onClose={handleSnackbarClose}
        severity={snackbarState.severity}
        message={snackbarState.message}
        position={snackbarState.position}
      />

      {/* Main Section */}
      <Card sx={{ flexGrow: 1, padding: 4, borderRadius: "20px" }}>
        {/* Sort and Filter */}

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: 2,
          }}
        >
          {/* Category Dropdown */}
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel id="category-label">Category</InputLabel>
            <Select
              labelId="category-label"
              value={selectedCategory} // Replace with your state for category
              onChange={(e) => setSelectedCategory(e.target.value)} // Update with your handler
              label="Category"
            >
              {categoriesData &&
                categoriesData.map((category) => (
                  <MenuItem
                    key={category.category_id}
                    value={category.category_id}
                  >
                    {category.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          {/* Brands Dropdown */}
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel id="brands-label">Brands</InputLabel>
            <Select
              labelId="brands-label"
              value={selectedBrand} // Replace with your state for brand
              onChange={(e) => setSelectedBrand(e.target.value)} // Update with your handler
              label="Brands"
            >
              {brandsData &&
                brandsData.map((brands) => (
                  <MenuItem key={brands.brand_id} value={brands.brand_id}>
                    {brands.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Box>
        <Box sx={{ display: "flex", gap: 2 }}>
          {/* Price Range Slider */}
          <Box sx={{ mb: 2, width: "50%" }}>
            <Typography variant="h6" fontWeight="bold">
              Price Range
            </Typography>
            <Slider
              value={priceRange}
              onChange={handleSliderChange}
              valueLabelDisplay="auto"
              min={0}
              max={750000}
              sx={{ width: "100%" }}
            />
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2">
                Price Range: ₹{priceRange[0]} - ₹{priceRange[1]}
              </Typography>
            </Box>
          </Box>

          {/* Deals & Discounts Dropdown */}
          <FormControl sx={{ width: "50%" }}>
            <InputLabel id="deals-label">Deals & Discounts</InputLabel>
            <Select
              labelId="deals-label"
              value={selectedDeal} // Replace with your state for deals
              onChange={(e) => setSelectedDeal(e.target.value)} // Update with your handler
              label="Deals & Discounts"
            >
              <MenuItem value="20% Off">20% Off</MenuItem>
              <MenuItem value="Buy 1 Get 1">Buy 1 Get 1</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <Box sx={{ display: "flex", gap: 2 }}>
          {/* <Select
            value={sortOption}
            onChange={handleSortChange}
            displayEmpty
            fullWidth
            sx={{ mt: 0 }}
          >
            <MenuItem value="">
              <em>Sort by</em>
            </MenuItem>
            <MenuItem value="allModels">All Models</MenuItem>
            <MenuItem value="quantities">Quantities</MenuItem>
            <MenuItem value="price">Price</MenuItem>
            <MenuItem value="offerPrice">Offer Price</MenuItem>
          </Select> */}
          <SearchComponent
            placeholder={"Search by name"}
            handleChange={handleSearch}
          />

          <Box>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setModalOpen(true);
                setIsediting(false);
              }}
              sx={{
                backgroundColor: "#28A745",
                "&:hover": { backgroundColor: "#218838" },
                textTransform: "none",
                fontWeight: "bold",
                mt: 1,
              }}
            >
              Add
            </Button>
          </Box>
        </Box>
        {/* <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)", // Automatically adjust columns
            gap: "16px", // Adds spacing between items
            justifyContent: "center",
            alignItems: "center", // Aligns items vertically in each row
            padding: "16px", // Increases padding for a balanced look
            backgroundColor: "#f9f9f9", // Optional: Adds a subtle background color
            borderRadius: "12px", // Optional: Adds rounded corners to the grid container
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // Optional: Adds shadow for depth
          }}
          mt={5}
        >
          { filteredData && filteredData.length>0 ?
           filteredData.map((data) => (
            <AdminProductCard
              key={data.id}
              title={data.name}
              summary={data.description}
              price={data.regularPrice}
              sales={data.sku}
              remaining={data.holescount}
              images={data?data.images:[]}
            />
          )):<Typography textAlign={'center'}>No Producsts Availabe</Typography>}
        </Box> */}

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)", // Responsive columns
            gap: "24px", // Consistent spacing
            padding: "24px",
            // backgroundColor: "#f9f9f9",
            borderRadius: "12px",
            // boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            // '@media (max-width: 960px)': {
            //   gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            // },
            "@media (max-width: 767px)": {
              gridTemplateColumns: "1fr",
            },
          }}
          mt={5}
        >
          {filteredData && filteredData.length > 0 ? (
            filteredData
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((data) => (
                <Box
                  key={data.id}
                  sx={{
                    height: "100%", // Ensure consistent height
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <AdminProductCard
                    // title={data.name}
                    // summary={data.description}
                    // price={data.regularPrice}
                    // sales={data.sku}
                    // remaining={data.holescount}
                    // images={data?.images || []}
                    data={data}
                    onMenuClick={handleMenuClick}
                    onDeleteClick={handleDeleteClick}
                    isEditing={handleEditing}
                  />
                </Box>
              ))
          ) : (
            <Typography
              sx={{
                gridColumn: "1 / -1",
                textAlign: "center",
                padding: "40px",
              }}
            >
              No Products Available
            </Typography>
          )}
        </Box>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredData && filteredData.length ? filteredData.length : 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />

        {/* Modal */}
        <Modal
          open={isModalOpen}
          onClose={handleModalClose}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)", // Center the modal
              width: "80vw",
              height: "90vh",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 2,
              overflowY: "scroll", // Enable vertical scrolling
              borderRadius: 2, // Rounded corners
              "&::-webkit-scrollbar": {
                display: "none", // Hide scrollbar for Webkit browsers
              },
              "-ms-overflow-style": "none", // Hide scrollbar for Internet Explorer and Edge
              "scrollbar-width": "none", // Hide scrollbar for Firefox
            }}
          >
            {/* Close Icon at the Top */}
            <Box
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                zIndex: 1,
              }}
            >
              <Button
                onClick={handleModalClose}
                variant="text"
                color="error"
                sx={{ minWidth: "auto", padding: 0 }}
              >
                ✖
              </Button>
            </Box>

            <Typography
              id="modal-title"
              variant="h6"
              component="h2"
              sx={{ mb: 2, textAlign: "center" }}
            >
              Add Product
            </Typography>
            {isModalOpen ? (
              <ProductFormAdmin
                onBack={handleOnBack}
                showSnackBar={handleSnackBar}
                data={menuData ? menuData : []}
                isEditing={isEditing}
                onModalOpen={handleModalClose}
              />
            ) : null}

            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleModalClose}
              >
                Close
              </Button>
            </Box>
          </Box>
        </Modal>
      </Card>
    </Box>
  );
}
